import React, { ReactNode } from 'react';

type CardProps = {
    children: ReactNode;
    theme?: 'light' | 'primary' | 'secondary' | 'accent';
    noPadding?: boolean;
    padding?: 's' | 'm' | 'l' | 'xl';
    fullHeight?: boolean;
    fullWidth?: boolean;
    fitContent?: boolean;
};

const themeClasses = {
    light: 'bg-white ',

    primary: 'bg-primary',
    secondary: 'bg-secondary',
    accent: 'bg-accent',
};

const Card: React.FC<CardProps> = ({ children, theme = 'light', noPadding = false, fullHeight = false, fullWidth = false, fitContent = false, padding = 'm' }) => {
    return (
        <div className={`${themeClasses[theme]} 
        ${noPadding ? 'p-0' : `${padding === 's' ? 'p-2' : padding === 'm' ? 'p-4' : padding === 'l' ? 'p-8' : 'p-12'}`} 
        ${fullHeight ? 'h-full' : ''} 
        ${fullWidth ? 'w-full' : ''} 
        ${fitContent ? 'w-fit h-fit' : ''} 
        
        rounded-lg shadow-xl border border-neutral-300`}>
            {children}
        </div>
    );
};

export default Card;